import React from 'react';

const I140I485Concurrent: React.FC = () => {
  return (
  <div className="bg-white min-h-screen text-left flex flex-col items-center py-10 px-4 pt-20">
    <div className="max-w-7xl w-full px-0 md:px-10">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0097b2] mb-4 leading-tight">I-140 and I-485 Concurrent Filing</h1>
      <div className="text-[22px] text-gray-700 mb-4">This page is under construction.</div>
    </div>
  </div>

  );
};

export default I140I485Concurrent;
